{
  "brand": "VBB PLAY",
  "tagline": "Premium gaming platform",
  "loading": "Loading…",
  "retry": "Try again",
  "close": "Close",
  "search": "Search",
  "seeAll": "See all",
  "comingSoon": "Coming soon",
  "currency": "AZN",
  "language": "Language",
  "selectLanguage": "Select language",
  "offlineHint": "Checking connection",
  "footerRights": "© {{year}} VBB PLAY. All rights reserved.",
  "footerSupport": "Support",
  "heroEyebrow": "PLAY BEYOND LIMITS",
  "heroTitle": "Bigger games, bolder wins",
  "heroSubtitle": "Play beyond limits — premium lobby, secure cashier, and curated games.",
  "heroCta": "Play now",
  "promoFallbackTitle": "Welcome bonus",
  "promoFallbackSubtitle": "Bonus and VIP programs are being prepared. Claim offers when campaigns go live.",
  "promoFallbackCta": "Claim now",
  "promoFilter_all": "All",
  "promoFilter_welcome": "Welcome",
  "promoFilter_casino": "Casino",
  "promoFilter_sports": "Sports",
  "promoFilter_vip": "VIP",
  "login": "Log in",
  "storyBonuses": "Bonuses",
  "storyVip": "VIP Cashback",
  "storyCashback": "Cashback",
  "storyCrypto": "Crypto",
  "storyInvite": "Invite a friend",
  "bonusSelectTitle": "Choose a bonus",
  "continue": "Continue",
  "supportWelcome": "Welcome to VBB PLAY",
  "supportPrechat": "Please enter your contact details and question before starting.",
  "supportEmail": "Email",
  "supportName": "Name",
  "supportMessage": "Message",
  "supportConsent": "I agree to personal data processing and the privacy policy.",
  "startDialogue": "Start dialogue",
  "attach": "Attach",
  "send": "Send",
  "support247": "Support 24/7",
  "supportInvite": "Our operators are ready to help.",
  "contactSupport": "Contact support",
  "infoSection": "Information",
  "referral": "Referral",
  "liveSports": "Live",
  "prematch": "Prematch",
  "fiatMethods": "Fiat",
  "fiatMethodsHint": "Card, M10, Terminal",
  "cryptoMethodsHint": "Supported crypto methods in Cashier",
  "personalInfo": "Personal information",
  "contactInfo": "Contact information",
  "displayName": "Name",
  "notAvailable": "Not available",
  "phone": "Phone",
  "profileEditHint": "Name, date of birth and gender are stored on your account.",
  "myProfile": "My profile",
  "securitySettings": "Security",
  "rewardCenter": "Reward center",
  "notificationsTitle": "Notifications",
  "markAllRead": "Mark all as read",
  "marketingOptIn": "Receive promotional notifications",
  "emptyNotifications": "No notifications",
  "notificationsUnavailable": "Event notifications appear here when generated. Nothing is fabricated.",
  "open": "Open",
  "protectionTitle": "Account protection",
  "coolingOff": "Start cooling-off",
  "selfExclude": "Self-exclude",
  "requestClosure": "Request account closure",
  "helpSupport": "Help & support",
  "promoCode": "Promo code",
  "redeem": "Redeem",
  "bonusHistory": "Bonus history",
  "promoLoginRequired": "Sign in to redeem a code.",
  "promoSuccess": "Credited {{amount}} AZN",
  "promo_invalid_code": "This code is not valid.",
  "promo_campaign_expired": "This promotion has expired.",
  "promo_campaign_inactive": "This promotion is not active.",
  "promo_campaign_not_started": "This promotion has not started.",
  "promo_per_user_limit": "You have already used this code.",
  "promo_unique_user_limit": "This promotion has reached its player limit.",
  "promo_usage_limit": "No redemptions remain for this promotion.",
  "promo_not_eligible": "You are not eligible for this promotion.",
  "promo_minimum_deposit_not_satisfied": "A qualifying deposit is required.",
  "promo_budget_exhausted": "This promotion's budget is exhausted.",
  "promo_too_many_requests": "Too many attempts. Try again later.",
  "promo_zero_reward": "This promotion has no cash reward to claim here.",
  "promo_redeem_failed": "Could not redeem this code.",
  "storyPromo": "Promo code",
  "liveSupport": "Live support",
  "sportsUnavailable": "Live sports betting is not available yet. Casino games remain open.",
  "linked": "Connected",
  "notLinked": "Not connected",
  "loadFailed": "Could not load",
  "unavailableTitle": "Not available",
  "vipUnavailable": "VIP levels are not configured yet.",
  "givenName": "First name",
  "familyName": "Last name",
  "dateOfBirth": "Date of birth",
  "gender": "Gender",
  "genderMale": "Male",
  "genderFemale": "Female",
  "genderOther": "Other",
  "genderPreferNot": "Prefer not to say",
  "saveProfile": "Save profile",
  "profileSaved": "Profile saved",
  "profileSaveFailed": "Could not save profile",
  "identityLockedNotice": "Your personal details are on file. Contact live support to request a change.",
  "identityChangeRequest": "Request a change",
  "identityChangeReason": "Reason for change",
  "identitySubmitRequest": "Submit request",
  "identityChangePending": "Your request is under review.",
  "identityChangeSubmitted": "Request sent. Live support will follow up.",
  "identityChangeFailed": "Could not send the request.",
  "identityNoChanges": "No changes to request.",
  "createdAt": "Account created",
  "ageIneligible": "This date of birth is below the legal age. Real-money play stays disabled.",
  "rateOperator": "Rate this conversation",
  "ratingComment": "Optional feedback",
  "submitRating": "Submit rating",
  "ratingThanks": "Thank you for the rating",
  "footerRules": "Rules",
  "footerPrivacy": "Privacy",
  "rulesLink": "Rules and policies",
  "footerLegalTitle": "Legal information",
  "footerLegalDraftBadge": "DRAFT",
  "footerLegalDraftNotice": "The details below are a local legal draft only. Until company registration and the licence are confirmed, this text does not claim that the details are verified, that VBB PLAY is licensed, or that VBB PLAY is authorised to lawfully conduct all gambling activities.",
  "footerCompanyLabel": "Company",
  "footerCompanyName": "Vbb Play Byte Lab Sociedad de Responsabilidad Limitada",
  "footerCountryLabel": "Country of registration",
  "footerCountryValue": "Costa Rica",
  "footerRegNumberLabel": "Registration number",
  "footerRegNumberValue": "2-101-918934",
  "footerAddressLabel": "Registered address",
  "footerAddressValue": "Provincia 04 San Jose, Canton 02 Escazu, San Rafael, 200 metres south of the Multiplaza de Escazu cinemas, Seiba Street, Centro Corporativo EBC, tenth floor, Invicta Legal office.",
  "footerLicenseNumberLabel": "Presented licence number",
  "footerLicenseNumberValue": "ALSI-207508070-FI1",
  "footerLicenseJurisdictionLabel": "Presented licence jurisdiction",
  "footerLicenseJurisdictionValue": "Anjouan, Union of the Comoros",
  "footerLegalAria": "Legal information",
  "footerLegalStatement": "© 2026 VBB Play. vbbplay.com Kosta-Rikada qeydiyyatdan keçmiş Vbb PLay Byte Lab Sociedad de Responsabilidad Limitada şirkətinə məxsusdur və onun tərəfindən idarə olunur, qeydiyyat nömrəsi 2-101-918934, hüquqi ünvanı: Provincia 04 San Jose, Canton 02 Escazu, San Rafael, Multiplaza de Escazu kinoteatrlarından 200 metr cənubda, Seiba küçəsi, Centro Corporativo EBC, onuncu mərtəbə, Invicta Legal ofisi. vbbplay.com Komor Adaları İttifaqının Avtonom Anjuan Adası Hökuməti tərəfindən lisenziyalaşdırılıb və tənzimlənir və ALSI-207508070-FI1 nömrəli lisenziya əsasında fəaliyyət göstərir. VbbPlay.com bütün tənzimləyici tələblərdən keçmişdir və hər cür qumar oyunları və mərc əməliyyatlarını qanuni şəkildə həyata keçirməyə səlahiyyətlidir.",
  "back": "Back",
  "rulesSelectAria": "Select a legal document",
  "scrollToTop": "Back to top",
  "footerAria": "Site footer",
  "footerLiveCasino": "Live casino",
  "footerProviders": "Providers",
  "footerFastGames": "Fast games",
  "footerEsports": "Esports",
  "footerTournaments": "Tournaments",
  "footerPartnership": "Partnership program",
  "footerTechSupport": "Technical support",
  "footerSupportSecurity": "Support and security",
  "footerSocial": "Social networks",
  "footerSocialPending": "Official social accounts will appear here once confirmed.",
  "footerAgeHint": "18+ only",
  "footerLegalAccordionTitle": "Legal information"
}
